import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./../../assets/css/ticket.scss";

const TicketModal = ({ isOpen, onClose }) => {
  const [activeCouponTicket, setActiveCouponTicket] = useState(null);
  const [couponValue, setCouponValue] = useState("");
  const [error, setError] = useState("");

  if (!isOpen) return null;

  const ticketData = [
    {
      id: 7,
      label: "Rotaract Entry",
      price: 299,
      link: "https://rzp.io/rzp/NZPjBg7",
      isCoupon: true,
      couponCode: "SMARTCITY"
    },
    {
      id: 8,
      label: "Student Pass",
      price: 299,
      link: "https://rzp.io/rzp/RS1bj0T",
      isCoupon: true,
      couponCode: "LP1104"
    },
    { id: 1, label: "Single Entry", price: 349, link: "https://rzp.io/rzp/g6XPhTBX" },
    { id: 2, label: "Single Entry + 1 Thandai", price: 399, link: "https://rzp.io/rzp/ozj2NvQQ" },
    { id: 3, label: "Couple Entry", price: 599, link: "https://rzp.io/rzp/yLn7bd8" },
    { id: 4, label: "Couple Entry + 1 Thandai", price: 699, link: "https://rzp.io/rzp/SbZZW32" },
    { id: 5, label: "Group 5 + 5 Drinks", price: 2499, link: "https://rzp.io/rzp/RbLqAnGo" },
    { id: 6, label: "Group 8 + 8 Drinks", price: 3999, link: "https://rzp.io/rzp/btB2boa" },
  ];

  const handleCouponSubmit = (ticket) => {
    if (couponValue.trim().toUpperCase() === ticket.couponCode) {
      window.open(ticket.link, "_blank");
      setActiveCouponTicket(null);
      setCouponValue("");
      setError("");
    } else {
      setError("Invalid Coupon Code");
    }
  };

  return ReactDOM.createPortal(
    <div className="custom-modal-overlay" onClick={onClose}>
      <div className="custom-modal-content" onClick={(e) => e.stopPropagation()}>
        
        <div className="modal-header-section">
          <button className="back-arrow" onClick={onClose}>←</button>
          <div className="header-text">
            <h4>Rang Barse 2.0 - Pune Ultimate Holi Bash 2026</h4>
            <p>Le Stone: Pune | Tue 03 Mar | 09:30 AM</p>
          </div>
        </div>

        <div className="modal-body-section">
          <div className="selection-header">
            <strong>Select Tickets</strong>
            <span>You can add up to 10 tickets only</span>
          </div>

          <div className="ticket-list">
            {ticketData.map((ticket) => (
              <div className="ticket-item" key={ticket.id}>
                
                <div className="ticket-details">
                  <span className="ticket-name">{ticket.label}</span>
                  <span className="ticket-price">
                    ₹{ticket.price.toLocaleString()}
                  </span>
                </div>

                {/* Normal Tickets */}
                {!ticket.isCoupon && (
                  <a
                    href={ticket.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="add-ticket-btn"
                  >
                    Add
                  </a>
                )}

                {/* Coupon Tickets */}
                {ticket.isCoupon && (
                  <>
                    {activeCouponTicket !== ticket.id && (
                      <button
                        className="add-ticket-btn"
                        onClick={() => {
                          setActiveCouponTicket(ticket.id);
                          setCouponValue("");
                          setError("");
                        }}
                      >
                        Add
                      </button>
                    )}

                    {activeCouponTicket === ticket.id && (
                      <div style={{ marginTop: "10px", width: "100%" }}>
                        <input
                          type="text"
                          placeholder="Enter Coupon Code"
                          value={couponValue}
                          onChange={(e) => setCouponValue(e.target.value)}
                          style={{
                            width: "100%",
                            padding: "8px",
                            borderRadius: "6px",
                            border: "1px solid #ccc"
                          }}
                        />

                        <button
                          className="add-ticket-btn"
                          style={{ marginTop: "8px" }}
                          onClick={() => handleCouponSubmit(ticket)}
                        >
                          Apply
                        </button>

                        {error && (
                          <p style={{ color: "red", marginTop: "5px" }}>
                            {error}
                          </p>
                        )}
                      </div>
                    )}
                  </>
                )}

              </div>
            ))}
          </div>
        </div>

      </div>
    </div>,
    document.body
  );
};

export default TicketModal;